import React from 'react';
import testimonialAvatar from '../assets/testimonial-avatar.jpg';
import { ReactComponent as TrustpilotStar } from '../assets/trustpilot-star.svg';

const TrustpilotStars = () => (
  <div className="flex items-center gap-0.5">
    {[0, 1, 2, 3].map((i) => (
      <div
        key={i}
        className="size-3 lg:size-6 bg-[#00B67A] flex items-center justify-center p-0.5"
      >
        <TrustpilotStar />
      </div>
    ))}
    <div className="size-3 lg:size-6 flex items-center justify-center overflow-hidden relative p-0.5">
      <div className="absolute inset-0 bg-[#00B67A]" style={{ width: '70%' }} />
      <div className="absolute inset-0 bg-[#DCDCE6]" style={{ left: '70%' }} />
      <div className="relative z-10">
        <TrustpilotStar />
      </div>
    </div>
  </div>
);

const TrustpilotLogo = () => (
  <div className="flex items-center gap-1">
    <div className="w-[15px] h-[14px]">
      <TrustpilotStar />
    </div>
    <span className="text-background text-sm font-semibold">Trustpilot</span>
  </div>
);

const MobileHero = () => (
  <div className="bg-twilight-blue px-8 py-10 flex flex-col gap-4 lg:hidden text-center w-screen relative left-1/2 -translate-x-1/2">
    <p className="text-background/80 text-base font-normal leading-6">
      Hello, nice to see you here!
    </p>
    <h1 className="text-background text-xl font-bold leading-5">
      Join 340,000+ people across Africa building careers in tech, creative, and
      entrepreneurship tracks.
    </h1>
  </div>
);

const MobileTestimonialAndStats = () => (
  <div className="bg-twilight-blue px-8 py-10 flex flex-col gap-10 lg:hidden w-screen relative left-1/2 -translate-x-1/2">
    <div className="border-l-4 border-lime-mist pl-5 flex flex-col gap-4">
      <p className="text-background text-sm font-medium leading-5">
        "I started as a high school student with an idea. Today, I'm a tech
        professional while building my own startup, Cheemba — a journey shaped
        through ALX programmes."
      </p>
      <div className="flex items-center gap-3">
        <img src={testimonialAvatar} alt="Oluwatosin A" className="w-9 h-9 rounded-full shrink-0 object-cover" />
        <div className="flex flex-col">
          <span className="text-background text-xs font-medium leading-4">
            Oluwatosin A
          </span>
          <span className="text-background/70 text-xs font-normal leading-3">
            Data Analytics Graduate
          </span>
        </div>
      </div>
    </div>

    <div className="flex items-center justify-between">
      <div className="flex flex-col gap-1">
        <span className="text-background text-xl font-normal leading-7">
          347K+
        </span>
        <span className="text-background/70 text-sm">graduates</span>
      </div>
      <div className="w-px self-stretch bg-background/20" />
      <div className="flex flex-col gap-1">
        <span className="text-background text-xl font-normal leading-7">
          43K+
        </span>
        <span className="text-background/70 text-sm">entrepreneurs</span>
      </div>
      <div className="w-px self-stretch bg-background/20" />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-background text-xl font-normal leading-7">
            4.7
          </span>
          <TrustpilotStars />
        </div>
        <TrustpilotLogo />
      </div>
    </div>
  </div>
);

export const RefereeLeftCard: React.FC = () => {
  return (
    <>
      <MobileHero />
      <div className="relative hidden h-full flex-col lg:flex bg-twilight-blue" />
      <div className="fixed hidden lg:flex top-0 left-0 bottom-0 w-[50vw] items-center pointer-events-none">
        <div className="flex flex-col justify-around h-full w-full max-w-2xl mx-auto px-16 py-10">
          <div className="flex flex-col gap-6">
            <p className="text-background/80 text-sm font-medium">
              Hello, nice to see you here!
            </p>
            <h1 className="text-background text-4xl font-bold leading-tight">
              Join 340,000+ people across Africa building careers in tech,
              creative, and entrepreneurship tracks.
            </h1>
          </div>

          <div className="border-l-4 border-lime-mist pl-5 flex flex-col gap-4">
            <p className="text-background text-xl leading-snug">
              "I started as a high school student with an idea. Today, I'm a
              tech professional while building my own startup, Cheemba — a
              journey shaped through ALX programmes."
            </p>
            <div className="flex items-center gap-3">
              <img src={testimonialAvatar} alt="Oluwatosin A" className="w-9 h-9 rounded-full shrink-0 object-cover" />
              <div className="flex flex-col">
                <span className="text-background text-sm font-semibold">
                  Oluwatosin A
                </span>
                <span className="text-background/70 text-xs">
                  Data Analytics Graduate
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1">
              <span className="text-background text-2xl font-bold">347K+</span>
              <span className="text-background/70 text-sm">graduates</span>
            </div>
            <div className="w-px self-stretch bg-background/20" />
            <div className="flex flex-col gap-1">
              <span className="text-background text-2xl font-bold">43K+</span>
              <span className="text-background/70 text-sm">entrepreneurs</span>
            </div>
            <div className="w-px self-stretch bg-background/20" />
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <span className="text-background text-2xl font-bold">4.7</span>
                <TrustpilotStars />
              </div>
              <TrustpilotLogo />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const RefereeBottomCard: React.FC = () => <MobileTestimonialAndStats />;
